
/* styles */
require("!!../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../vue-loader/lib/style-rewriter?id=data-v-7cac9f26!../../vue-loader/lib/selector?type=styles&index=0!./Handsontable.vue")

var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../vue-loader/lib/selector?type=script&index=0!./Handsontable.vue"),
  /* template */
  require("!!../../vue-loader/lib/template-compiler?id=data-v-7cac9f26!../../vue-loader/lib/selector?type=template&index=0!./Handsontable.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-handsontable/src/Handsontable.vue
// module id = 304
// module chunks = 2